import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';
import { getCookie } from '../../../components/common/Helpers';

const isFWAFLowRedesign = getCookie('isFWAFLowRedesign')==='Y';

const ProgressivePlansComponent = isFWAFLowRedesign
  ? Loadable(() => import('../containers/redesign/index'))
  : Loadable(() => import('../containers/index'));

export default MapTo('vcg/components/soe-home/react/progressiveplans')(ProgressivePlansComponent);
